import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";

const useGetGreetingMessage = ({ enabled }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isFetched, setIsFetched] = useState(false);

  const getData = useCallback(() => {
    setLoading(true);
    const baseUrl = window.localStorage.getItem("BaseURL");
    const endpoint = "/services/projectmanagement/api/ai-bot/chat/greeting";
    const fullUrl = baseUrl + endpoint;

    axiosInstance
      .get(fullUrl)
      .then((res) => {
        setData(res.data);
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false);
        setIsFetched(true);
      });
  }, []);

  useEffect(() => {
    if (enabled) {
      getData();
    }
  }, [getData, enabled]);

  return { data, loading, isFetched };
};

export default useGetGreetingMessage;
